


export const PROJECT_NAME = "KarimAlden"

export const TOKEN_KEY = PROJECT_NAME +  "_TOKEN"


